import { render, staticRenderFns } from "./JournalVoucherPrint.vue?vue&type=template&id=a5bf83fc&"
import script from "./JournalVoucherPrint.vue?vue&type=script&lang=js&"
export * from "./JournalVoucherPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports